import { leadService } from "./lead.service";
import { blogService } from "./blog.service";
import { userService } from "./user.service";
import { categoryService } from "./category.service";
import { mediaService } from "./media.service";
import { testimonialService } from "./testimonial.service";
import { customerStoryService } from "./customerstory.service";
import { fileService } from "./file.service";
import { applicationService } from "./application.service";
import { affiliatePlanService } from "./affiliate.plans.service";
import { foreCastService } from "./forecast.service";
import { creditService } from "./credit.service";
import { notificationService } from "./notification.service";
import { ledgerService } from "./ledger.service";
import { organisationService } from "./organisation.service";
import { communicationService } from "./communication.service";
import { eventService } from "./event.service";
import { emailService } from "./emailmessage.service";
import { creditorService } from "./creditor.service";

import { kanbanService } from "./kanban.service";

import { upstreamService } from "./upstream.service";
import { onboardingService } from "./onboarding.service";
import { bankService } from "./bank.service";
import { loansService } from "./loan.service";
import { paymentService } from "./payment.service";
import { pandaDocService } from "./pandadoc.service";
import * as strategyService from "./strategy.service";
import { walletService } from "./wallet.service";
import { paymentJobService } from "./payment.job.service";
import { communicationChannelService } from "./communication-channel.service";
import { sessionService } from "./session.service";
import { negotiationService } from "./negotiation.service";
import { miscFilesService } from "./misc.file.service";
import { taskTemplateService } from "./task-template.service";
import { taskBoardService } from "./task-board.service";

export const ApiService = {
  user: userService,
  lead: leadService,
  blog: blogService,
  category: categoryService,
  communication: communicationService,
  media: mediaService,
  testimonial: testimonialService,
  customerStory: customerStoryService,
  file: fileService,
  application: applicationService,
  affiliatePlans: affiliatePlanService,
  forecast: foreCastService,
  credit: creditService,
  notification: notificationService,
  ledger: ledgerService,
  organisation: organisationService,
  event: eventService,
  email: emailService,
  creditor: creditorService,

  kanban: kanbanService,

  upstream: upstreamService,
  onboarding: onboardingService,
  bank: bankService,
  loans: loansService,
  payment: paymentService,
  pandadoc: pandaDocService,
  strategy: strategyService,
  wallet: walletService,
  paymentJob: paymentJobService,
  communicationChannel: communicationChannelService,
  session: sessionService,
  negotiation: negotiationService,
  miscFiles: miscFilesService,
  taskTemplate: taskTemplateService,
  taskBoard: taskBoardService,
};
